import axios from 'axios';
import {
  COLLECTIONS_LOAD_PROJECT_DETAIL_COLLECTIONS_BEGIN,
  COLLECTIONS_LOAD_PROJECT_DETAIL_COLLECTIONS_SUCCESS,
  COLLECTIONS_LOAD_PROJECT_DETAIL_COLLECTIONS_FAILURE,
  COLLECTIONS_LOAD_PROJECT_DETAIL_COLLECTIONS_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function loadProjectDetailCollections(args = {}) {
  return (dispatch) => {
    dispatch({
      type: COLLECTIONS_LOAD_PROJECT_DETAIL_COLLECTIONS_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/`,
        args.data,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: COLLECTIONS_LOAD_PROJECT_DETAIL_COLLECTIONS_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_LOAD_PROJECT_DETAIL_COLLECTIONS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadProjectDetailCollectionsError() {
  return {
    type: COLLECTIONS_LOAD_PROJECT_DETAIL_COLLECTIONS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_LOAD_PROJECT_DETAIL_COLLECTIONS_BEGIN:
      return {
        ...state,
        loadProjectDetailCollectionsPending: true,
        loadProjectDetailCollectionsError: null,
      };

    case COLLECTIONS_LOAD_PROJECT_DETAIL_COLLECTIONS_SUCCESS:
      return {
        ...state,
        loadProjectDetailCollectionsPending: false,
        loadProjectDetailCollectionsError: null,
        projectDetail: action.data,
      };

    case COLLECTIONS_LOAD_PROJECT_DETAIL_COLLECTIONS_FAILURE:
      return {
        ...state,
        loadProjectDetailCollectionsPending: false,
        loadProjectDetailCollectionsError: action.data.error,
      };

    case COLLECTIONS_LOAD_PROJECT_DETAIL_COLLECTIONS_DISMISS_ERROR:
      return {
        ...state,
        loadProjectDetailCollectionsError: null,
      };

    default:
      return state;
  }
}
